import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyWorld } from "../../../../actions/mods_factory/worldsActions";
import { useNavigate } from "react-router-dom";
import { selectWorldEntities, selectWorldIds, setEditId } from "../../../../store/mods_factory/worldsSlice";

import { message, Spin } from "antd";
import { LikeOutlined, MessageOutlined } from "@ant-design/icons";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import IconText from "../../../../componets/IconText";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import {formattedDate} from "../../../../helpers/DateHelpers";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(selectWorldIds);
  const worlds     = useAppSelector(selectWorldEntities);
  const count     = useAppSelector(state => state.modsFactory.worlds.count);
  const error     = useAppSelector(state => state.modsFactory.worlds.error);
  const status    = useAppSelector(state => state.modsFactory.worlds.status);

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyWorld(id));

    if (destroyWorld.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyWorld.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderWorld = (id: EntityId) => {
    const world = worlds[id];

    if (!world) {
      return;
    }
    const formattedCreatedAt = formattedDate(world.created_at);

    return (
      <CardImage
        key={world.id}
        image={world.thumbnail_url}
        title={world.title}
        link={world.url}
        stats={[
          <IconText icon={LikeOutlined} text={world.likes_count} />,
          <IconText icon={MessageOutlined} text={world.comments_count} />
        ]}
        options={[
          <ButtonEdit key={`edit-${world.id}`} onClick={() => onClickEdit(world.id)} />,
          <ButtonDestroy key={`destroy-${world.id}`} onClick={() => onClickDestroy(world.id)} />
        ]}
      >
        <div className='v-small_text'>
          {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderWorld)}

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
